import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { InputBase, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BiteAPIapi from 'api/BITEapiAPI';


interface IAPIModalProps {
    type: string;
    handleClose: any;
    handleNotify: any;
    name: string;
    path: string;
    setName:any;
    endpoint: string;
    setPath: any;
    method: string;
    setEndpoint: any;
    params: any;
    setMethod: any;
    setParams: any;
    token: string;
    setToken: any;
    id: string;
    cur_user: any;
    trigger: boolean;
    setTrigger: any;
  }

const StyledInput = styled(InputBase)({
  borderRadius: 4,
  color: 'white',
  position: 'relative',
  backgroundColor: 'transparent',
  fontSize: 16,
  width: '100%',
  padding: 'none',
});

const BlankInput = styled(InputBase)({
  color: '#BDBEC1',
  position: 'relative',
  backgroundColor: 'transparent',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 20,
  width: '100%',
  padding: 'none',
});

const StyledSelect = styled(Select)({
  'display': 'flex',
  'padding': '10px 14px',
  'alignItems': 'center',
  'gap': '8px',
  'alignSelf': 'stretch',
  'borderRadius': '8px',
  'background': 'var(--Background-300, #2E3036)',
  'boxShadow': '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  'width': '70%',
  ':focus-visible': {
    outline: '0px'
  },
  '.MuiInputBase-input': {
    padding: '0px',
    overflow: 'hidden',
    color: 'var(--Text-Secondary, #BDBEC1)',
    textOverflow: 'ellipsis',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
  '.MuiSelect-icon': {
    fill: '#BDBEC1'
  },
  '.Mui-focused': {
    border: '0px'
  },
});

const MenuProps = {
  PaperProps: {
    style: {
      background: '#2E3036',
      width: 250,
      color: '#BDBEC1'
    },
  },
};

const StyledTableCell = styled(TableCell)(() => ({
  color: '#BDBEC1',
  border: 0,
  [`&.${tableCellClasses.head}`]: {
    backgroundColor:'#2E3036',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: '#202227',
  borderBottom: '1px solid #2E3036',
}));

const APIModal: React.FC<IAPIModalProps> = (props: IAPIModalProps) => {
  const { type, handleClose, handleNotify, name, setName, path, setParams, setPath, params, endpoint, setEndpoint, method, setMethod, token, setToken, id, cur_user, trigger, setTrigger } = props;


  useEffect(() => {
    if (type === 'retrieve' && id.length === 0) {
      setName('');
      setPath('https://app.bitedata.com/datahub/');
      setEndpoint('');
      setMethod('POST');
      setParams([
        { key: 'Primary', value: '' },
        { key: 'Indecies', value:  '' },
        { key: 'Quantity', value: '' },
        { key: 'Country', value:  '' },
        { key: 'Agency', value:  '' },
        { key: 'List', value:  '' },
        { key: 'Section', value:  '' },
        { key: 'Chapter', value:  '' },
        { key: 'HS Code', value:  '' },
      ]);
    } else if (id.length === 0) {
      setName('');
      setPath('');
      setEndpoint('');
      setMethod('');
      setToken('');
      setParams([]);
    }
  }, [ trigger ]);

  const handleSubmit = async() => {
    if (!(name.length > 0) || !(path.length > 0) || !(endpoint.length > 0) || !(method.length > 0) || (!(token.length > 0) && type === 'connect')) {
      handleNotify('fail');
    } else {
      const arr = [ ... params ];
      const useableParams = arr.filter((param: any) => {
        if (param.value.length > 0) {
          return param;
        }
      });

      if (id.length > 0) {
        const query = {
          _id: id,
          name: name,
          type: type,
          path: path,
          endpoint: endpoint,
          methodType: method,
          token: token,
          params: useableParams
        };

        const res = await BiteAPIapi.updateAPI(query);
        if (res?.success) {
          handleNotify('success');
          setTrigger(!trigger);
        }
      } else {
        const query = {
          name: name,
          type: type,
          path: path,
          endpoint: endpoint,
          methodType: method,
          token: token,
          params: useableParams,
          groupId: cur_user.selected_team?.id,
        };

        const res = await BiteAPIapi.createAPI({ newBITEApi: query });
        if (res?.success) {
          handleNotify('success');
          setTrigger(!trigger);
          handleClose();
        }
      }
    }
  };


  const randomId = () => {
    const s4 = () => {
      return (((1 + Math.random()) * 0x10000)|0).toString(16).substring(1);
    };
    return (`${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`);
  };

  return (
    <div className='new-api-modal-paper'>
      <div className='new-api-modal-head'>
        <div className='api-icon-div'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
        <div className='api-modal-head-words'>
          <div className='api-modal-head-title'>
            <h1>{type === 'connect' ? 'New Automation API' : 'New Screening API'}</h1>
            <svg onClick={handleClose} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <h2>{type === 'connect' ? 'Fill out the criteria to connect your data to BITE.' : 'Fill out the criteria to retrieve BITE data for your platform.'}</h2>
        </div>
      </div>
      <div className='api-modal-scrollable'>
        <div className='api-modal-form'>
          <div className='api-modal-form-row'>
            <h3 className='api-modal-form-key'>API Name*</h3>
            <div className='api-modal-form-input-cont'>
              <StyledInput value={name} onChange={(e: any) => setName(e.target.value)}></StyledInput>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_16081_242)'>
                  <path d='M6.06004 6.00001C6.21678 5.55446 6.52614 5.17875 6.93334 4.93943C7.34055 4.70012 7.8193 4.61264 8.28483 4.69248C8.75035 4.77233 9.17259 5.01436 9.47676 5.3757C9.78093 5.73703 9.94741 6.19436 9.94671 6.66668C9.94671 8.00001 7.94671 8.66668 7.94671 8.66668M8.00004 11.3333H8.00671M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001C1.33337 4.31811 4.31814 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
                </g>
                <defs>
                  <clipPath id='clip0_16081_242'>
                    <rect width='16' height='16' fill='white'/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className='api-modal-form-row'>
            <h3 className='api-modal-form-key'>Context path*</h3>
            <div className='api-modal-form-input-cont'>
              {type === 'retrieve' ? (
                <StyledInput value={path}></StyledInput>
              ) : (
                <StyledInput value={path} onChange={(e: any) => setPath(e.target.value)}></StyledInput>
              )}
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_16081_242)'>
                  <path d='M6.06004 6.00001C6.21678 5.55446 6.52614 5.17875 6.93334 4.93943C7.34055 4.70012 7.8193 4.61264 8.28483 4.69248C8.75035 4.77233 9.17259 5.01436 9.47676 5.3757C9.78093 5.73703 9.94741 6.19436 9.94671 6.66668C9.94671 8.00001 7.94671 8.66668 7.94671 8.66668M8.00004 11.3333H8.00671M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001C1.33337 4.31811 4.31814 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
                </g>
                <defs>
                  <clipPath id='clip0_16081_242'>
                    <rect width='16' height='16' fill='white'/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          {type === 'connect' && <div className='api-modal-form-row'>
            <h3 className='api-modal-form-key'>API key token*</h3>
            <div className='api-modal-form-input-cont'>
              <StyledInput value={token} onChange={(e: any) => setToken(e.target.value)}></StyledInput>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_16081_242)'>
                  <path d='M6.06004 6.00001C6.21678 5.55446 6.52614 5.17875 6.93334 4.93943C7.34055 4.70012 7.8193 4.61264 8.28483 4.69248C8.75035 4.77233 9.17259 5.01436 9.47676 5.3757C9.78093 5.73703 9.94741 6.19436 9.94671 6.66668C9.94671 8.00001 7.94671 8.66668 7.94671 8.66668M8.00004 11.3333H8.00671M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001C1.33337 4.31811 4.31814 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
                </g>
                <defs>
                  <clipPath id='clip0_16081_242'>
                    <rect width='16' height='16' fill='white'/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>}
          {type === 'retrieve' ? (
            <div className='api-modal-form-row'>
              <h3 className='api-modal-form-key'>Type*</h3>
              <StyledSelect
                IconComponent={KeyboardArrowDownIcon}
                value={endpoint}
                MenuProps={MenuProps}
                onChange={(e: any) => setEndpoint(e.target.value)}
              >
                <MenuItem value={'entities'}>People / Companies</MenuItem>
                <MenuItem value={'products'}>Products</MenuItem>
                <MenuItem value={'cyber'}>Cyber</MenuItem>
              </StyledSelect>
            </div>
          ) : (
            <div className='api-modal-form-row'>
              <h3 className='api-modal-form-key'>Endpoint URL*</h3>
              <div className='api-modal-form-input-cont'>
                <StyledInput value={endpoint} onChange={(e: any) => setEndpoint(e.target.value)}></StyledInput>
              </div>
            </div>
          )}
          <div className='api-modal-form-row'>
            <h3 className='api-modal-form-key'>Request Method*</h3>
            <StyledSelect
              IconComponent={KeyboardArrowDownIcon}
              value={method}
              MenuProps={MenuProps}
              onChange={(e: any) => {
                if (type === 'connect') {
                  setMethod(e.target.value);
                }
              }}
            >
              <MenuItem value={'GET'}>GET</MenuItem>
              <MenuItem value={'POST'}>POST</MenuItem>
              <MenuItem value={'PUT'}>PUT</MenuItem>
              <MenuItem value={'DELETE'}>DELETE</MenuItem>
            </StyledSelect>
          </div>
        </div>
        <div className='api-modal-params-cont'>
          <h4>Parameters (Optional)</h4>
          <TableContainer component={Paper} className='api-table-paper'>
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead className='api-table-head'>
                <TableRow>
                  <StyledTableCell>Key</StyledTableCell>
                  <StyledTableCell>Value</StyledTableCell>
                  {type === 'connect' && <StyledTableCell align='right' sx={{ width: '10%' }}>Delete</StyledTableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {params.map((row: any, i: number) => (
                  <StyledTableRow
                    key={randomId()}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <StyledTableCell component='th' scope='row'>
                      { type === 'connect' ? (
                        <BlankInput defaultValue={row.key} onChange={(e: any) => {
                          const newArr = params;
                          newArr[i].key = e.target.value;
                          setParams(newArr);
                        }}></BlankInput>
                      ) : (
                        <BlankInput value={row.key}></BlankInput>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      <BlankInput defaultValue={row.value} onChange={(e: any) => {
                        const newArr = params;
                        newArr[i].value = e.target.value;
                        setParams(newArr);
                      }}></BlankInput>
                    </StyledTableCell>
                    {type === 'connect' && <StyledTableCell align='right' sx={{ width: '15%' }}><svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' style={{ cursor: 'pointer' }} onClick={() => {
                      const newArr = [ ...params ];
                      newArr.splice(i, 1);
                      setParams(newArr);
                    }}>
                      <path d='M13.3333 5V4.33333C13.3333 3.39991 13.3333 2.9332 13.1517 2.57668C12.9919 2.26308 12.7369 2.00811 12.4233 1.84832C12.0668 1.66666 11.6001 1.66666 10.6667 1.66666H9.33333C8.39991 1.66666 7.9332 1.66666 7.57668 1.84832C7.26308 2.00811 7.00811 2.26308 6.84832 2.57668C6.66667 2.9332 6.66667 3.39991 6.66667 4.33333V5M8.33333 9.58333V13.75M11.6667 9.58333V13.75M2.5 5H17.5M15.8333 5V14.3333C15.8333 15.7335 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7335 4.16667 14.3333V5' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg></StyledTableCell>}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {type === 'connect' && <h5 onClick={() => setParams([ ...params, { key: '', value: '' } ])}>+ Add Parameter</h5>}
        </div>
        <div className='new-api-modal-btns'>
          <Button
            onClick={handleClose}
            sx={{ color: '#BDBEC1', border: '1px solid #2E3036', textTransform: 'none', width: '50%', padding: '10px 14px', borderRadius: '8px' }}
          >Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            sx={{ color: '#EFF1F6', background: '#4895EF', textTransform: 'none', width: '50%', padding: '10px 14px', borderRadius: '8px' }}
          >Submit
          </Button>
        </div>
      </div>
    </div>

  );
};

export default APIModal;
